module.exports = __webpack_public_path__ + "img/profesional_de_confianza.9dc5f373.png";